module.exports = __webpack_public_path__ + "fonts/aveny-tinstagram-medium-webfont.5e8493a1.woff";